// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 9651) return "static/chunks/9651.9be695e992890e60.js";
	if (chunkId === 219) return "static/chunks/219.bdca67d43c5fd4fa.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 9424 ? "638014a0" : chunkId) + "-" + {"2359":"5fc5d82f496f823f","9278":"c6211239365ccb30","9424":"a177fea63aaa2cb5"}[chunkId] + ".js";
};